import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import editIcon from 'images/icons/invite/edit.svg';
import Tooltip from 'components/ui/Tooltip';
import ModalWithoutTitle from 'components/ui/ModalWithoutTitle';
import Form from './Form';

export default function Index({ note }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        bsStyle="link"
        className="pl0 pr0 mr5"
        onClick={() => setShowModal(true)}
        data-tip="Edit"
      >
        <img src={editIcon} alt="edit" />
      </Button>

      <ModalWithoutTitle
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Form note={note} closeForm={() => setShowModal(false)} />
      </ModalWithoutTitle>

      <Tooltip />
    </>
  );
}

Index.propTypes = {
  note: PropTypes.object.isRequired,
};
